

import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

/**
 * Timer Component & GetDefferncceTime Utility
 *
 * Timer displays a countdown based on a date, lead status, and user actions, with lock/unlock UI logic.
 *
 * Features:
 * - Calculates time difference from a given date
 * - Shows countdown timer for locked state
 * - Handles timer pause/resume and unlock actions
 * - Displays different UI based on lead status and timer state
 * - Supports navigation and custom click handlers
 *
 * Props (Timer):
 * - date: Date string for countdown calculation
 * - lead_status: Status to determine lock/unlock UI
 * - classes: CSS classes for styling
 * - link: URL for navigation
 * - items: Data object for custom actions
 * - handleCheckLockClick: Optional callback for unlock action
 * - navigate: Navigation function
 * - setLoading: Function to set loading state
 */
function GetDefferncceTime(date) {
    const updated_at = date;

    // Convert the updated_at timestamp to a Date object
    const updatedAtDate = new Date(updated_at);

    // Get the current time as a Date object
    const currentDate = new Date();
    // Calculate the time difference in milliseconds
    const timeDifference = currentDate.getTime() - updatedAtDate.getTime();

    // Convert the time difference to hours
    const hoursDifference = timeDifference / (1000 * 60 * 60);
    return hoursDifference
}


function Timer({ date, lead_status, classes, link, items, handleCheckLockClick = null, navigate, setLoading }) {
    let hoursDifference = GetDefferncceTime(date)

    const totalWaitingTime = 2 * 3600
    const [timeRemaining, setTimeRemaining] = useState(0); // Convert hours to seconds
    //const [timeRemaining, setTimeRemaining] = useState(0.01 * 3600);
    const [timerActive] = useState(true);


    useEffect(() => {
        let left_time = totalWaitingTime - (hoursDifference * 3600)
        setTimeRemaining(left_time)
    }, [hoursDifference, totalWaitingTime])

    useEffect(() => {
        let interval;
        if (timerActive && timeRemaining > 0) {
            interval = setInterval(() => {
                setTimeRemaining((prevTime) => prevTime - 1);
            }, 1000); // One second in milliseconds
        }
        return () => clearInterval(interval);
    }, [timerActive, timeRemaining]);

    const hours = Math.floor(timeRemaining / 3600);
    const minutes = Math.floor((timeRemaining % 3600) / 60);
    // const seconds = timeRemaining % 60;
    if (timeRemaining > 0) {
        return (
            <div>

                <div className="blue fw-semibolder text-gray">Locked for  <span className=' text-success me-2'>{hours.toString().substring('0', 2)}:{minutes.toString().substring('0', 2)}</span></div>
                {/* <div className='d-dark w-100'>
                    <span className='bg-dark rounded text-white d-dark fs-3 border-2 p-2 me-2'>{hours.toString().substring('0', 2)}</span><b>:</b>
                    <span className='bg-dark rounded text-white d-dark fs-3 border-2 p-2 me-2'>{minutes.toString().substring('0', 2)}</span><b>:</b>
                    <span className='bg-dark rounded text-white d-dark fs-3 border-2 p-2'>{seconds.toString().substring('0', 2)}</span>
                </div> */}
                {/* <button onClick={() => setTimerActive(!timerActive)}>
                {timerActive ? 'Pause' : 'Resume'}
            </button> */}
            </div>
        );
    } else {
        return lead_status === 1 ? (
            <div className={classes}>
                <span className="symbol-label fs-6 fw-semibold text-white bg-danger">
                    <i className="bi bi-lock-fill text-white fs-5 fw-semibold"></i>
                </span>
            </div>
        ) : (
            <>{
                handleCheckLockClick ? (
                    <div onClick={() => handleCheckLockClick(items?.calling_id, navigate, setLoading)}>
                        <div className={classes}>
                            <span className="symbol-label fs-6 fw-semibold text-white bg-dark bg-hover-success">
                                <i className="bi bi-telephone-fill text-white fs-5 fw-semibold"></i>
                            </span>
                        </div>
                    </div>
                ) : (
                    <Link to={link} className={classes}>
                        <span className="symbol-label fs-6 fw-semibold text-white bg-dark bg-hover-success">
                            <i className="bi bi-telephone-fill text-white fs-5 fw-semibold"></i>
                        </span>
                    </Link>
                )
            }
            </>

        )
    }

}

export default Timer;
